
const ImageGallery = ({ images, openModal }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-1 p-8 px-4 bg-zinc-800 ">
      {images.map((image, index) => (
       <div
          onClick={() => openModal(image.projectName)}
          key={index}
          className="flex flex-col hover:cursor-pointer"
        >
          <div className="relative group">
            <p className="
              absolute inset-0
              hidden group-hover:flex
              items-center justify-center
              text-xl text-white
              bg-[rgba(0,0,0,.5)]
            ">
              ADDITIONAL PHOTOS
            </p>

            <div className="h-56 w-full bg-white overflow-hidden">
              <img
                src={image.backgroundImage}
                alt={`Image ${index}`}
                className="
                  w-full h-full
                  object-cover
                  rounded
                  block
                "
              />
            </div>
          </div>

          <div className="p-4 bg-zinc-300 rounded-b text-xl">
            <p className="
              w-full
              text-zinc-800
              font-small
              py-6
              whitespace-nowrap
              overflow-hidden
              text-ellipsis
            ">
              {image.projectName}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImageGallery;
